import { render, staticRenderFns } from "./Healing.vue?vue&type=template&id=a1d1896e&scoped=true"
import script from "./Healing.vue?vue&type=script&lang=js"
export * from "./Healing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d1896e",
  null
  
)

export default component.exports